module.exports = __webpack_public_path__ + "img/bgAr.315ea56d.png";